var noop = function() {};
export { noop }; //# sourceMappingURL=noop.js.map
